import SectionHeader from "@/components/base/SectionHeader";
import CTAButton from "@/components/base/CTAButton";

type Project = {
  title: string;
  desc: string;
  tech: string[];
  image: string;
};

const projects: Project[] = [
  {
    title: "Connect-Verse",
    desc: "A paid membership dating platform where members can meet and interact with single Men/Women from around the country.",
    tech: ["React", "Paystack", "Node.js"],
    image:"/images/mockup2.png",
  },
  {
    title: "ACS - RSU Chapter",
    desc: "A clean, modern and mobile responsive website for the Rivers State University Chapter of the American Chemical Society(ACS).",
    tech: ["Next.js", "Tailwind CSS", "SEO"],
    image:"/images/mockup1.png",
  },
  {
    title: "Atlas Logistics",
    desc: "A shipment-tracking portal for a regional logistics company, giving customers real-time visibility into every order.",
    tech: ["React", "PostgreSQL", "APIs"],
    image:
      "https://readdy.ai/api/search-image?query=A%20shipment%20tracking%20logistics%20dashboard%20interface%20mockup%20on%20a%20clean%20light%20background%2C%20modern%20delivery%20management%20web%20app%20with%20maps%20and%20data%20panels%2C%20red%20accent%20highlights%2C%20professional%20SaaS%20UI%20presentation%2C%20crisp%20and%20detailed&width=800&height=600&seq=emchon-work-07&orientation=landscape",
  },
];

export default function Work() {
  return (
    <section className="w-full px-4 md:px-6 lg:px-10 py-14 md:py-20">
      <div className="mx-auto max-w-[1280px]">
        <SectionHeader
          eyebrow="Featured Work"
          title="A look at what we've designed and built."
          subtitle="A few recent client projects. Explore the full portfolio — including concept work and experiments — on our work page."
        />

        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-6">
          {projects.map((p) => (
            <div
              key={p.title}
              className="group rounded-lg border border-background-200 bg-background-50 overflow-hidden transition-all duration-300 hover:-translate-y-1 hover:border-primary-300"
            >
              <div className="relative h-48 w-full overflow-hidden bg-background-100">
                <img
                  src={p.image}
                  alt={p.title}
                  title={`${p.title} — Client Work by EMCHON Technologies`}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute top-3 left-3 inline-flex items-center gap-1.5 rounded-full bg-primary-500 px-3 py-1 text-[11px] font-semibold text-foreground-950 tracking-wide">
                  CLIENT WORK
                </span>
              </div>

              <div className="p-6">
                <h3 className="font-heading text-xl font-bold text-foreground-950">
                  {p.title}
                </h3>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed">
                  {p.desc}
                </p>
                <div className="mt-4 flex flex-wrap gap-2">
                  {p.tech.map((t) => (
                    <span
                      key={t}
                      className="rounded-md bg-background-100 px-2.5 py-1 text-xs text-foreground-600"
                    >
                      {t}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-10 text-center">
          <CTAButton to="/work" variant="dark" icon="ri-arrow-right-line">
            View All Work
          </CTAButton>
        </div>
      </div>
    </section>
  );
}